import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { ContractService } from 'src/app/clinical/contracts/services/contracts.service';
import { ClinicalState } from 'src/app/clinical/store/clinical.state';
import * as performanceEvalActions from 'src/app/clinical/store/actions';

@Injectable()
export class PerformanceEvalEffects {
    getPerformanceEval$ = createEffect(() =>
        this.actions$.pipe(
            ofType(performanceEvalActions.loadPerformanceEval),
            switchMap((action) =>
                this.contractService.getPerformanceEval(action.payload.contract.id).pipe(
                    mergeMap((response) => [
                        performanceEvalActions.loadPerformanceEvalSuccess({
                            payload: { performanceEval: response }
                        })
                    ]),
                    catchError((error) =>
                        of(
                            performanceEvalActions.loadPerformanceEvalFail({
                                payload: { contract: action.payload.contract }
                            })
                        )
                    )
                )
            )
        )
    );

    storePerformanceEval$ = createEffect(() =>
        this.actions$.pipe(
            ofType(performanceEvalActions.storePerformanceEval),
            switchMap((action) =>
                this.contractService.storePerformanceEvalForm(action.payload.performanceEval).pipe(
                    map((response) => {
                        return performanceEvalActions.storePerformanceEvalSuccess({
                            payload: { performanceEval: response }
                        });
                    }),
                    catchError((error) =>
                        of(
                            performanceEvalActions.storePerformanceEvalFail({
                                payload: { error }
                            })
                        )
                    )
                )
            )
        )
    );

    constructor(
        private readonly store$: Store<ClinicalState>,
        private readonly actions$: Actions,
        private readonly contractService: ContractService
    ) {}
}
